import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  NavigateToPasswordResetButton,
  AuthenticationSubmitButton,
} from '../../Components';

export const DefaultLayout = () => {
  const { onSubmit, unsourcedErrors } = useMetaLayoutContext();
  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'authentication-default-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <MetaLayoutRemainingFields />
        <AuthenticationSubmitButton />
        <NavigateToPasswordResetButton />
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};
